
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type CategoryPaginationRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function CategoryPaginationRT(): TemplateResult<CategoryPaginationRTRootProps> {
    return _createElement('div', {}, [this.pagination(function () {
            function repeatButtons1(buttons, buttonsIndex) {
                return [buttons(function () {
                        return this.template === 'prev' ? _createElement('li', { 'className': 'cmTemplate_prev' }, _createElement('a', {
                            'href': this.pageLink,
                            'className': 'pagination__item pagination__item--next pagination__item-arrow link motion-reduce page-light',
                            'aria-label': 'Go to previous page'
                        }, [_createElement('svg', {
                                'className': 'icon icon-caret',
                                'width': '14',
                                'height': '8',
                                'viewBox': '0 0 14 8',
                                'fill': 'none',
                                'key': '2000'
                            }, _createElement('path', {
                                'd': 'M1 1L7 7L13 1',
                                'stroke': 'currentColor',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round'
                            }))])) : this.template === 'page' ? _createElement('li', { 'className': 'cmTemplate_page' }, !this.isActive ? _createElement('a', {
                            'href': this.pageLink,
                            'className': 'pagination__item',
                            'aria-label': 'Go to page ' + this.page,
                            'key': '33'
                        }, '\n      ', this.page, '\n    ') : null, this.isActive ? _createElement('span', {
                            'className': 'pagination__item pagination__item--current',
                            'key': '175'
                        }, this.page) : null) : this.template === 'delimiter' ? _createElement('li', { 'className': 'cmTemplate_delimiter' }, _createElement('span', { 'className': 'pagination__item pagination__item page-light' }, _translate(`pagination_delimiter_text`))) : this.template === 'next' ? _createElement('li', { 'className': 'cmTemplate_next' }, _createElement('a', {
                            'href': this.pageLink,
                            'className': 'pagination__item pagination__item--prev pagination__item-arrow link motion-reduce page-light',
                            'aria-label': 'Go to next page'
                        }, [_createElement('svg', {
                                'className': 'icon icon-caret',
                                'width': '14',
                                'height': '8',
                                'viewBox': '0 0 14 8',
                                'fill': 'none',
                                'key': '1960'
                            }, _createElement('path', {
                                'd': 'M1 1L7 7L13 1',
                                'stroke': 'currentColor',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round'
                            }))])) : _createElement('div', { 'className': 'cmTemplate_Unknown' }, JSON.stringify(this));
                    }, { count: undefined })];
            }
            return _createElement('nav', { 'className': 'pagination cm_pagination' }, _createElement.apply(this, [
                'ul',
                { 'className': 'cm_mobile-hide pagination__list list-unstyled cmRepeater_buttons' },
                _map(this.buttons, repeatButtons1.bind(this))
            ]));
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.SearchResult(function () {
            return _createElement('div', { 'className': 'cm_SearchResult__load-more cm_SearchResult' }, [this.loadMore(function () {
                    return _createElement('div', { 'className': 'cm_loadMore' }, _createElement('div', { 'className': 'cm_load-more' }, this.isNotAllItemsReceived ? [
                        this.isActive ? [this.loading] : null,
                        !this.isActive ? [[this.loadMoreButton(function () {
                                    return _createElement('div', {
                                        'className': 'button cm_loadMoreButton',
                                        'onClick': this.activate
                                    }, '\n        ', window.Convermax.config?.loadMoreText || _translate(`load_more`, {  nextPageSize : this. nextPageSize  }), '\n      ');
                                }, {
                                    widgetName: 'undefined',
                                    items: undefined
                                })]] : null
                    ] : null));
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })]);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:pagination","cm:loadMoreButton","cm:loadMore","cm:SearchResult"]